// Generated by ReScript, PLEASE EDIT WITH CARE


var twoWheelerNumeric = "2 wheeler";

var twoWheelerShort = "2w";

var twoWheelerString = "two wheeler";

var twoWheelerSnakeCase = "two_wheeler";

var twoWheelerAlternative = "bike";

var twoWheelerKebabCase = "two-wheelers";

var twoWheelerSingularKebabCase = "two-wheeler";

var motorcycle = "motorcycle";

var canter3Tonne = "canter_3_tonne";

var oneTon7Feet = "1_ton_7_feet";

var pickup1Tonne = "pickup_1_tonne";

var pickup1_5Tonne = "pickup 1.5ton";

var pickup1_Ton = "pickup 1ton";

var minivan = "minivan";

var cng = "cng";

var compact = "compact";

var courier = "courier";

var truckSingular = "truck";

var trucks = "trucks";

var partload = "partload";

var packersMovers = "packers-movers";

export {
  twoWheelerNumeric ,
  twoWheelerShort ,
  twoWheelerString ,
  twoWheelerSnakeCase ,
  twoWheelerAlternative ,
  twoWheelerKebabCase ,
  twoWheelerSingularKebabCase ,
  motorcycle ,
  canter3Tonne ,
  oneTon7Feet ,
  pickup1Tonne ,
  pickup1_5Tonne ,
  pickup1_Ton ,
  minivan ,
  cng ,
  compact ,
  courier ,
  truckSingular ,
  trucks ,
  partload ,
  packersMovers ,
}
/* No side effect */
